
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directory",
      function () {
        return require("private-next-pages/directory/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directory"])
      });
    }
  